import {
  BREAKDOWN_ID_FIELD,
  BREAKDOWN_ID_PREFIX,
  BREAKDOWN_KEY,
  BREAKDOWN_NAME_FIELD
} from "../recipeImpactChart.constants";
import { BreakdownItem, BreakdownType, ImpactBreakdown } from "../recipeImpactChart.types";

/** Reads a breakdown list from a raw impact object, defaulting to an empty array. */
export const getBreakdownList = (breakdown: ImpactBreakdown, type: BreakdownType): any[] =>
  (breakdown?.[BREAKDOWN_KEY[type]] as any[]) ?? [];

/** Builds the stable, type-prefixed id used to de-duplicate a breakdown item. */
export const buildItemId = (item: any, type: BreakdownType): string =>
  `${BREAKDOWN_ID_PREFIX[type]}${item[BREAKDOWN_ID_FIELD[type]]}`;

/** Reads the display name for a breakdown item based on its type. */
export const getItemName = (item: any, type: BreakdownType): string =>
  item[BREAKDOWN_NAME_FIELD[type]];

/** Returns the climate impact a single breakdown contributes for one item, or 0. */
export const findImpactForItem = (breakdown: ImpactBreakdown, item: BreakdownItem): number => {
  const list = getBreakdownList(breakdown, item.type);
  const match = list.find(entry => buildItemId(entry, item.type) === item.id);
  return match?.climateImpact || 0;
};
